<template>
  <a-layout-content :style="{ padding: '0 10px', marginTop: '86px' }">
    <div :style="{ background: '#fff', padding: '24px', minHeight: '380px' }">
      <a-result
        status="success"
        :title="this.$t('ujian.finish.title')"
        :sub-title="sub_title"
      >
        <template #extra>
          <a-button key="console" type="primary" @click="logout()"> Log out </a-button>
        </template>
      </a-result>
    </div>
  </a-layout-content>
</template>
<script>
export default {
  props: ["finish"],
  data() {
    return {
      sub_title: this.$t('ujian.finish.sub-title'),
    };
  },
  methods:{
    logout(){
      this.$store.commit("resetState");
      localStorage.removeItem("vuex");
      this.$router.push("login");
    }
  }
};
</script>